/**
 * Lightweight JWT claim parsing — no verification, just payload extraction.
 *
 * Used by AuthProvider to read user info from ID tokens without importing
 * a full JWT library. Token verification happens server-side (API Gateway +
 * aws-jwt-verify); the client only needs to read claims.
 */
/** Decode base64url to UTF-8 string. */
function decodeBase64UrlToUtf8(value) {
    if (!value)
        return null;
    try {
        const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
        const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
        const binary = atob(padded);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new TextDecoder("utf-8").decode(bytes);
    }
    catch {
        return null;
    }
}
/** Parse the payload section of a JWT into a plain object. */
export function parseJwtClaims(token) {
    if (!token)
        return null;
    const parts = token.split(".");
    if (parts.length < 2)
        return null;
    const payload = decodeBase64UrlToUtf8(parts[1]);
    if (!payload)
        return null;
    try {
        return JSON.parse(payload);
    }
    catch {
        return null;
    }
}
